import jwt_decode from "jwt-decode";
import moment from 'moment';
import { getBasicAuthCredentials } from './auth-credentials';
import { getStore } from '../store';

export const getDefaultAccount = async (userId, token) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  let url = `${window.URL_GET_ACCOUNTS}/${userId}/account/default`;
  if (window.currentUser && window.currentUser.env) {
    url += `?env=${window.currentUser.env}`;
  }

  const res = await fetch(url, { method: "GET", headers: myHeaders });
  const user = await res.json();

  // Obtener y guardar las credenciales de NextCloud en Redux
  if (user.errors.length === 0 && user.data !== null && user.data.configAccount !== null) {
    try {
      const basicAuthToken = await getBasicAuthCredentials(userId, user.data.configAccount.imapUser, token);
      const store = getStore();
      store.dispatch({ type: 'NEXTCLOUD_ACCOUNT_AUTH', payload: basicAuthToken });
    } catch (error) {
      console.error('Error getting NextCloud credentials in getDefaultAccount:', error);
    }
  }

  return user;
};

export const getUserAccounts = async (userId, token) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  let url = `${window.URL_GET_ACCOUNTS}/${userId}`;
  if (window.currentUser && window.currentUser.env) {
    url += `?env=${window.currentUser.env}`;
  }

  const res = await fetch(url, { method: "GET", headers: myHeaders });
  const user = await res.json();

  // Note: getUserAccounts returns multiple accounts, credentials will be fetched
  // when a specific account is selected via getUserAccount

  return user;
};

export const getUserAccount = async (userId, account, token) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  let url = `${window.URL_GET_ACCOUNTS}/${userId}/account/imap/${account}`;
  if (window.currentUser && window.currentUser.env) {
    url += `?env=${window.currentUser.env}`;
  }

  const res = await fetch(url, { method: "GET", headers: myHeaders });
  const user = await res.json();

  // Obtener y guardar las credenciales de NextCloud en Redux
  if (user.errors.length === 0 && user.data !== null) {
    try {
      const basicAuthToken = await getBasicAuthCredentials(userId, account, token);
      const store = getStore();
      store.dispatch({ type: 'NEXTCLOUD_ACCOUNT_AUTH', payload: basicAuthToken });
    } catch (error) {
      console.error('Error getting NextCloud credentials in getUserAccount:', error);
    }
  }

  return user;
};

export const getLexonUserId = async (userId, token) => {
  let url = `${window.API_GATEWAY}/api/v1/lexauth/Lexon/user/getid?entry=${userId}`;
  if (window.currentUser && window.currentUser.env) {
    url += `&env=${window.currentUser.env}`;
  }

  const res = await fetch(url, { method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  });
  const user = await res.json();

  return user;
};

export const getUser = async (userId, token, env) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  let url = `${window.URL_GET_ACCOUNTS}/${userId}`;
  const url2 = `${window.API_GATEWAY}/api/v1/utilsauth/Lexon/token/lexon?addTerminatorToToken=true`;
  if (window.currentUser && window.currentUser.env || env) {
    url += `?env=${window.currentUser?.env || env}`;
  }

  try {
    const res = await fetch(url, { method: "GET", headers: myHeaders });
    const user = await res.json();
    const res2 = await fetch(url2, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        idClienteNavision: userId,
        env:
      (window.currentUser && window.currentUser.env) ? window.currentUser.env : env ? env : window.REACT_APP_ENVIRONMENT
      })
    }); const navUser = await res2.json();
    user.data.lexonUserId = navUser.data.idUser;
    const userData = jwt_decode(navUser.data.token, { complete: true });
    user.data.tokenDecoded = userData;

    return user;
  } catch (err) {
    console.error('Error fetching user:', err);
  }
};

export const addOrUpdateAccount = async (userId, account, token) => {
  const url = `${window.URL_GET_ACCOUNTS}/${userId}/account/addorupdate`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(account)
  });

  const user = await res.json();
  return user;
};

export const addOrUpdateSign = async ({
  userId,
  provider,
  email,
  name,
  sign,
  isDefault,
  action = "",
  lexonToken
}) => {
  const actions = {
    create: "POST",
    update: "PUT"
  };

  const url = `${window.URL_GET_ACCOUNTS}/${userId}/sign`;

  const res = await fetch(url, {
    method: actions[action] || "",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${lexonToken}`
    },
    body: JSON.stringify({
      provider,
      email,
      name,
      sign,
      isDefault
    })
  });

  const response = await res.json();
  return response;
};

export const deleteSign = async ({
  userId,
  provider,
  email,
  name,
  lexonToken
}) => {
  const url = `${window.URL_GET_ACCOUNTS}/${userId}/sign`;

  const res = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${lexonToken}`
    },
    body: JSON.stringify({
      provider,
      email,
      name
    })
  });

  const response = await res.json();
  return response;
};

export const getEmailTemplates = async ({userId, lexonToken}) => {
  const url = `${window.URL_GET_EVENTSTYPE}/accounts/auth/EmailTemplates/${userId}/get`;
  const res = await fetch(url, { method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${lexonToken}`
    } });
  const templates = await res.json();

  return templates;
};

export const getUserFolders = async (userId, email, lexonToken) => {
  const url = `${window.URL_GET_EVENTSTYPE}/accounts/auth/usermail/${userId}/${email}/folders`;
  const res = await fetch(url, { method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${lexonToken}`
    } });
  const folders = await res.json();

  return folders;
};

export const updateOrderFolderImap = async (folders, userId, email, lexonToken) => {
  const url = `${window.URL_GET_EVENTSTYPE}/accounts/auth/usermail/${userId}/${email}/folders/update`;
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${lexonToken}`
    },
    body: JSON.stringify(folders)
  });

  const result = await response.json();

  return result;
};

export const addOrUpdateTemplate = async (newTemplateData, token) => {
  const actions = {
    create: "POST",
    update: "PUT"
  };

  const url = `${window.URL_GET_EVENTSTYPE}/accounts/auth/EmailTemplates/${newTemplateData.actionUrl}`;

  let body = {
    user: newTemplateData.userId,
    name: newTemplateData.name,
    template: newTemplateData.template,
    isDefault: newTemplateData.isDefault
  };

  if (newTemplateData._id) {
    body = {
      ...body,
      _id: newTemplateData._id,
      creationDate: newTemplateData.creationDate,
      modifiedDate: newTemplateData.modifiedDate,
      vs: newTemplateData.vs
    };
  }

  const res = await fetch(url, {
    method: actions[newTemplateData.action] || "",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  });

  const response = await res.json();
  return response;
};

export const deleteTemplate = async ({templateId, lexonToken}) => {
  const url = `${window.URL_GET_EVENTSTYPE}/accounts/auth/EmailTemplates/delete?templateId=${templateId}`;

  const res = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${lexonToken}`
    },
    body: JSON.stringify({})
  });

  const response = await res.json();
  return response;
};

export const resetDefaultAccount = async (userId, lexonToken) => {
  const url = `${window.URL_GET_ACCOUNTS}/${userId}/account/reset`;

  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${lexonToken}`);
  const res = await fetch(url, {
    method: "POST",
    headers: myHeaders
  });

  const user = await res.json();
  return user;
};

export const classifyEmail = async (
  id,
  subject,
  date,
  to,
  folder,
  provider,
  account,
  bbdd,
  idCompany,
  userId,
  token
) => {
  let url = `${window.API_GATEWAY}/api/v1/lexauth/Contacts/${idCompany}/user/${userId}/conn/${bbdd}`;
  if (window.currentUser && window.currentUser.env) {
    url += `?env=${window.currentUser.env}`;
  }

  const classification = {
    contactList: [...to],
    mail: {
      provider: provider,
      mailAccount: account,
      uid: id,
      subject: subject,
      date: moment(date).format("YYYY-MM-DD HH:mm:ss"),
      folder
    },
    stateId: 1
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(classification)
  });
  const data = await response.json();

  return data;
};

export const getEventTypes = async (account, token) => {
  const url = `${window.URL_GET_EVENTSTYPE}/evauth/get`;

  const value = {
    email: account
  };

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(value)
  });

  let user = null;
  try {
    user = await res.json();
  } catch {
    user = null;
  }

  // Event types endpoint can respond 404 for accounts without configuration.
  // Return a safe empty payload to avoid breaking calendar rendering.
  if (res.status === 404) {
    return { data: { eventTypes: [] } };
  }

  if (!res.ok) {
    const requestError = new Error(`getEventTypes failed with status ${res.status}`);
    requestError.status = res.status;
    requestError.response = user;
    throw requestError;
  }
  return user || { data: { eventTypes: [] } };
};

export const updateEventTypeColorMode = async (email, colorMode, token) => {
  const url = `${window.URL_GET_EVENTSTYPE}/evauth/settings`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      email,
      eventTypeColorMode: colorMode
    })
  });

  const response = await res.json();
  return response;
};

export const addorUpdateEventType = async (eventType, token) => {
  const url = `${window.URL_GET_EVENTSTYPE}/evauth/eventtype/add`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(eventType)
  });
  const eventtype = await res.json();
  return eventtype;
};

export const deleteEventType = async (eventType, token) => {
  const url = `${window.URL_GET_EVENTSTYPE}/evauth/eventtype/delete`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(eventType)
  });
  const eventtype = await res.json();
  return eventtype;
};


export const getTokenImap = async token => {
  const url = `${window.API_GATEWAY}/api/v1/utils/UserUtils/token/imap?addTerminatorToToken=true&validateCaducity=false`;
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(token)
  });

  const newToken = await response.json();
  return newToken;
};

export const dataUrlToFile = ({dataUrl, mimeType}) => {
  const byteCharacters = window.atob(dataUrl);

  let byteNumbers = byteCharacters.length;
  const byteArray = new Uint8Array(byteNumbers);

  while (byteNumbers--) {
    byteArray[byteNumbers] = byteCharacters.charCodeAt(byteNumbers);
  }
  return new Blob([byteArray], {
    type: mimeType
  });
};

export const getOneEntity = async (
  bbdd,
  idCompany,
  idUser,
  idEntity,
  env,
  token
) => {
  const response = await fetch(`${window.API_GATEWAY}/api/v1/entauth/${idCompany}/get`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      bbdd,
      idUser,
      idEntity: parseInt(idEntity, 10),
      idType: 14,
      env
    })
  });
  const string = await response.text();
  const result = string === "" ? {} : JSON.parse(string);
  return result;
};

export const getFilesDocument = async (
  bbdd,
  idCompany,
  idUser,
  idEntity,
  env,
  token
) => {
  const response = await fetch(`${window.API_GATEWAY}/api/v1/entauth/${idCompany}/files/get`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      bbdd,
      idUser,
      idEntity: parseInt(idEntity, 10),
      env
    })
  });
  const string = await response.text();
  const result = string === "" ? {} : JSON.parse(string);
  return result;
};

export const getEncodeProducts = async (userId, token) => {
  let url = `${window.API_GATEWAY}/api/v1/utilsauth/userutils/user/encode?idNavisionUser=${userId}`;
  if (window.currentUser && window.currentUser.env) {
    url += `&env=${window.currentUser.env}`;
  }
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  const res = await fetch(url, { method: 'GET', headers: myHeaders });
  const encodeProducts = await res.json();
  return encodeProducts;
};

export const getCompanies = (entry, idNavision, token) => new Promise((resolve, reject) => {
  let url = `${window.API_GATEWAY}/api/v1/lexauth/Lexon/companies?entry=${entry}&idNavision=${idNavision}`;
  if (window.currentUser && window.currentUser.env) {
    url += `&env=${window.currentUser.env}`;
  }
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  fetch(url, {
    method: "GET",
    headers: myHeaders
  })
    .then(data => data.json())
    .then(result => {
      resolve({
        companies: result.data,
        errors: result.errors
      });
    })
    .catch(error => {
      reject(error);
    });
});


